import { UPDATE_ENABLE_GOOGLE_AMP_OUTPUT_OVERRIDE } from './actionTypes';
export const updateEnableGoogleAmpOutputOverride = enableGoogleAmpOutputOverride => {
  return {
    type: UPDATE_ENABLE_GOOGLE_AMP_OUTPUT_OVERRIDE,
    payload: enableGoogleAmpOutputOverride
  };
};